async function getMax() {
  try {
    const resData = await window.axios.get('/api/v1/admin/league/max');
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

async function setMax(params) {
  try {
    const resData = await window.axios.put('/api/v1/admin/league/max', params);
    return resData.data;
  } catch (err) {
    console.log(err);
    throw err;
  }
}

module.exports = { setMax, getMax };
